// extracted by mini-css-extract-plugin
export default {"square":"spaceAssignmentSelect_square__ltuf0"};